
<template>
	<page>
		<module>
			<view-list
				ref="view"
				work-type="20"
				selector
			>
				<template #search>
					<m-search ref="search">
						<m-search-item label="背贴码">
							<m-code-batch-input name="produce_unique_codes" field-name="背贴码" placeholder="请输入背贴码，支持批量"></m-code-batch-input>
						</m-search-item>
						<m-search-item label="IMEI">
							<m-code-batch-input name="produce_imeis" field-name="IMEI" placeholder="请输入IMEI，支持批量"></m-code-batch-input>
						</m-search-item>
						<m-search-item label="产品信息">
							<c-input name="product_name"></c-input>
						</m-search-item>
						<m-search-item label="询价渠道">
							<c-select name="channel_id" async @search="searchChannel"></c-select>
						</m-search-item>
					</m-search>
				</template>

				<template #operate>
					<c-button v-if="auth('b_inquiry_list_export')" prepend-icon="tf-export" @click="exportInquiryList()">导出</c-button>
				</template>

				<template #product_info="{data}">
					<m-product-info :name="data.product_info || getProductText(data)" :level="data.level_type" :code="data.produce_unique_code" :imei="data.produce_imei"></m-product-info>
				</template>

				<template #produce_unique_code="{data}">
					{{data.produce_unique_code}} <c-link color="gray" @click="$copy(data.produce_unique_code)"><i class="tf">&#xe6b0;</i></c-link>
				</template>

				<template #produce_imei="{data}">
					{{data.produce_imei}} <c-link v-if="data.produce_imei" color="gray" @click="$copy(data.produce_imei)"><i class="tf">&#xe6b0;</i></c-link>
				</template>

				<template #inquiry_amount="{data}">
					{{formatPrice(data.inquiry_amount)}}
				</template>

				<template #return_price="{data}">
					<span style="color: #e53e3e;">{{formatPrice(data.return_price)}}</span>
				</template>

				<template #channel_name="{data}">
					{{data.channel_name || '-'}}
				</template>
                <template #state="{data}">
					<c-state dict="INQUIRY_STATE" :value="data.state"></c-state>
				</template>
			</view-list>
		</module>
	</page>
</template>

<script>
	import CState from "@/components/public/state.vue";

    export default {
        components: {CState},
		methods: {
			/*********搜索询价渠道**********/
			searchChannel(keyword, resolve) {
				this.request({
					url: '/sale/product/channel/options',
					data: {
						keyword: keyword
					},
					success: data => {
						resolve((data || []).map(item => {
							return {
								name: item.channel_name,
								value: item.channel_id
							};
						}));
					}
				});
			},

			/*********导出询价列表**********/
			exportInquiryList() {
				var search = this.$refs.search ? this.$refs.search.get() : {};
				this.request({
					url: '/sale/inquiry/export/url',
					data: Object.assign({
						view_id: this.$refs.view.getViewId()
					}, search),
					success: data => {
						if (data && data.url) {
							window.open(data.url);
						}
					}
				});
			},

			/*********格式化价格**********/
			formatPrice(price) {
				if (price === null || price === undefined || price === '') return '-';
				return '¥' + parseFloat(price).toFixed(2);
			},

			/*********获取产品信息文字**********/
			getProductText(data) {
				var parts = [];
				if (data.brand_name) parts.push(data.brand_name);
				if (data.model_name) parts.push(data.model_name);
				if (data.memory_name) parts.push(data.memory_name);
				if (data.color_name) parts.push(data.color_name);
				return parts.join(' ') || '-';
			}
		}
	}
</script>

<style lang="stylus" scoped>
	.m-product-info {
		line-height: 24px;
		font-size: 13px;
		color: #333;

		.m-product-info-name {
			display: flex;
			align-items: center;
			gap: 4px;
		}
	}
</style>
